import { Identifiable } from '@approvalmax/types';
import { Popup } from '@approvalmax/ui';
import { Box } from '@approvalmax/ui/src/components';
import { memo, useCallback, useState } from 'react';

import { messages } from './LineItemsGroupEdit.messages';
import { Cell, NameCell, Table } from './LineItemsGroupEdit.styles';
import { LineItemsGroupEditProps } from './LineItemsGroupEdit.types';

export const LineItemsGroupEdit = memo(
    <Item extends Identifiable | Identifiable[]>(props: LineItemsGroupEditProps<Item>) => {
        const { items, onClose } = props;

        const [values, setValues] = useState<Record<(typeof items)[number]['id'], Item | null>>({});

        const handleClose = useCallback(() => {
            onClose();
        }, [onClose]);

        const handleSave = useCallback(() => {
            items.forEach((item) => {
                const val = values[item.id];

                if (val) {
                    item.onSave(val);
                }
            });

            onClose();
        }, [items, onClose, values]);

        return (
            <Popup isOpen={true} onRequestClose={handleClose}>
                <Popup.DefaultContent
                    title={messages.title}
                    buttons={
                        <Popup.DefaultContent.Button execute={handleSave}>{messages.save}</Popup.DefaultContent.Button>
                    }
                >
                    <Box spacing='0 40 40'>
                        <Table>
                            <tbody>
                                {items.map((item, index) => (
                                    <tr key={index}>
                                        <NameCell>{item.name}</NameCell>

                                        <Cell>
                                            {item.render({
                                                onChange: (value) => {
                                                    if (item.prepareChange) {
                                                        setValues(item.prepareChange(value, values));
                                                    } else {
                                                        setValues({ ...values, [item.id]: value });
                                                    }
                                                },
                                                value: values[item.id],
                                                values: values,
                                            })}
                                        </Cell>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Box>
                </Popup.DefaultContent>
            </Popup>
        );
    }
);

LineItemsGroupEdit.displayName = 'LineItemsGroupEdit';
